import { mergeRight } from 'ramda';

import { ICreateMessageRequest } from '../../../repositories/demand/v4/create-message';
import { TMappedAnswersState } from '../types';
import { getMessageSource } from '../../../utils/getMessageSource';
import { ICreatePersonalMessageRequest } from '../../../repositories/demand/v2/create-personal-message';
import { EMortgageBankApprove } from '../../../repositories/demand/entities/public_v4_create_message/RequestMessageV4Schema';

interface IParams {
  mappedAnswersState: TMappedAnswersState;
  isWebview: boolean;
  platform: string | null;
  cian_source: string | undefined;
}

const params = {
  isBankDeposit: false,
  isHasOffer: false,
  isMortgageInitialPayment: false,
  isReadyToLower: false,
  mortgageBankApprove: EMortgageBankApprove.No,
};

const DEFAULT_SOURCE = 'request-form-realtor';
const DEFAULT_PERSONAL_SOURCE = 'personal-request-form-realtor';

/** Добавляет обязательные значения по умолчанию */
export const createRequestPayload = ({
  mappedAnswersState,
  isWebview,
  platform,
  cian_source,
}: IParams): ICreateMessageRequest => {
  const source = getMessageSource({ isWebview, platform, cian_source, defaultSource: DEFAULT_SOURCE });

  return mergeRight(
    {
      ...params,
      source,
    },
    mappedAnswersState,
  );
};

/** Добавляет обязательные значения по умолчанию для персональной заявки */
export const createRequestPayloadForPersonal = ({
  platform,
  isWebview,
  mappedAnswersState,
  cian_source,
}: IParams): ICreatePersonalMessageRequest => {
  const specialistIds = mappedAnswersState.realtorListing.map(item => Number(item));

  const source = getMessageSource({
    isWebview,
    platform,
    cian_source,
    defaultSource: DEFAULT_PERSONAL_SOURCE,
  });

  return mergeRight(
    {
      ...params,
      source,
      specialistIds,
    },
    mappedAnswersState,
  );
};
